export default __webpack_public_path__ + "static/media/Mask Group 30@2x.731a3ef8.png";